import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function WarrantySubSection() {
  return (
    <VFKit.SubSection
      data-testid="warranty-section"
      title={i18n.t('entity.vehicle.labels.warrantyAndValidity')}
      useCard
    >
      <VFKit.Group data-testid="warranty-fields" columns={[1, 2, 4]}>
        <VFKit.WarrantyDatePicker />
        <VFKit.SimpleNumericField name="warrantyMileage" />
        <VFKit.ServiceContractUntilDatePicker />
        <VFKit.SimpleNumericField name="serviceContractMileageLimit" />
      </VFKit.Group>
      <VFKit.ServiceContractNoteTextarea />
    </VFKit.SubSection>
  );
}
